import styles from "./PreviewSkeleton.module.scss";

const PreviewSkeleton = () => {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.preview} skeleton`} />

      <div className={styles.footer}>
        <div className={`${styles.lineLg} skeleton`} />
        <div className={`${styles.lineMd} skeleton`} />
      </div>
    </div>
  );
};

export default PreviewSkeleton;
